<form [formGroup]="form" (ngSubmit)="onSubmit()"
      class="h-full w-full overflow-x-hidden overflow-y-auto flex flex-col items-center justify-start space-y-4">

  <div class="mt-6 mb-3">
    <h1 class="text-primary">¡Sigue avanzando!</h1>
  </div>

  <app-selected
    class="w-full"
    [config]="dataSelected().at(0)"
    (selectValue)="handleValue($event)"
  ></app-selected>

  @if (showPublicJobFields) {
    @for (config of publicJobInputs(); track config.formName) {
      <app-input
        class="w-full"
        [config]="config"
        [timeoutSeconds]="1"
        (submitValue)="handleInputValue($event)"
      ></app-input>
    }
  }

  <app-selected
    class="w-full"
    [config]="dataSelected().at(1)"
    (selectValue)="handleValue($event)"
  ></app-selected>

  @if (showPepRelativeFields) {
    <app-input
      class="w-full"
      [config]="pepRelativeInputs()[0]"
      [timeoutSeconds]="1"
      (submitValue)="handleInputValue($event)"
    ></app-input>

    <app-selected
      class="w-full"
      [config]="pepDocumentTypeSelected()"
      (selectValue)="handleValue($event)"
    ></app-selected>

    @for (config of pepRelativeInputs().slice(1); track config.formName) {
      <app-input
        class="w-full"
        [config]="config"
        [timeoutSeconds]="1"
        (submitValue)="handleInputValue($event)"
      ></app-input>
    }
  }

  @for (config of dataSelected().slice(2, 5); track config.formName) {
    <app-selected
      class="w-full"
      [config]="config"
      (selectValue)="handleValue($event)"
    ></app-selected>
  }

  @if (form.get('isObligatedTaxOtherCountry')!.value === true || form.get('isObligatedTaxOtherCountry')!.value === 'true') {
    <div class="flex flex-col justify-center items-start w-full h-auto relative">
      <label for="obligatedTaxCountryInput" class="text-label">
        Indique cuál <b class="text-sub-label">*</b>
      </label>

      <div class="w-full h-10 flex justify-center items-center px-2 py-1 rounded-sm shadow-lg border border-blue-700 bg-white relative">
        <input
          type="text"
          id="obligatedTaxCountryInput"
          [(ngModel)]="inputCountryValue"
          [ngModelOptions]="{ standalone: true }"
          autocomplete="off"
          (ngModelChange)="onSearchChange($event)"
          placeholder="Selecciona un país"
          class="border-none focus:outline-none focus:ring-0 rounded px-3 py-2 w-full h-8 placeholder:text-gray-500"
          [ngClass]="{
            'is-invalid': (form.get('obligatedTaxCountryId')?.invalid || form.hasError('invalidCountry'))
                        && (isTimeout || form.get('obligatedTaxCountryId')?.touched)
          }"
        />
        @if (isLoadingCountries) {
          <div class="absolute right-3 top-1/2 -translate-y-1/2">
            <div class="w-4 h-4 border-2 border-blue-500 border-t-transparent rounded-full animate-spin"></div>
          </div>
        }
      </div>

      @if (filteredCountries.length > 0) {
        <div class="absolute w-full top-full left-0 z-50">
          <ul class="w-full bg-white border border-gray-300 rounded-md shadow-lg mt-1 max-h-52 overflow-y-auto">
            @for (country of filteredCountries; track country.id) {
              <li
                class="px-4 py-2 hover:bg-blue-100 cursor-pointer transition-colors duration-150"
                (click)="selectCountry(country)"
              >
                {{ country.name }}
              </li>
            }
          </ul>
        </div>
      }

      @if ((form.get('obligatedTaxCountryId')?.invalid || form.hasError('invalidCountry'))
              && (isTimeout || form.get('obligatedTaxCountryId')?.touched)) {
        <div class="text-red-500 text-[10px] mt-1">
          Por favor selecciona un país válido de la lista
        </div>
      }
    </div>

    <!-- Campo TIN -->
    <div class="flex flex-col justify-center items-start w-full">
      <label for="tinInput" class="text-label">
        Número de Identificación Tributaria (TIN) <b class="text-sub-label">*</b>
      </label>

      <div class="w-full h-10 flex justify-center items-center px-2 py-1 rounded-sm shadow-lg border border-blue-700 bg-white relative">
        <input
          type="text"
          id="tinInput"
          formControlName="tinNumber"
          [placeholder]="getTinPlaceholder()"
          (input)="onTinInput($any($event.target).value)"
          class="border-none focus:outline-none focus:ring-0 rounded px-3 py-2 w-full h-8 placeholder:text-gray-500 text-sm"
          [ngClass]="{
            'is-invalid': form.get('tinNumber')?.invalid && (form.get('tinNumber')?.touched || isTimeout)
          }"
        />

        @if (isLoadingFormats) {
          <div class="absolute right-3 top-1/2 -translate-y-1/2">
            <div class="w-4 h-4 border-2 border-blue-500 border-t-transparent rounded-full animate-spin"></div>
          </div>
        }
      </div>

      @if (selectedCountryFormats.length > 0) {
        <div class="text-xs text-gray-500 mt-1 space-y-0.5">
          <span class="font-medium">Formatos aceptados:</span>
          @for (format of selectedCountryFormats; track format.id) {
            <div class="flex items-center gap-2">
              <span class="text-[10px] text-gray-600">- {{ format.description || 'Sin descripción' }}</span>
            </div>
          }
        </div>
      }

      @if (form.get('tinNumber')?.hasError('invalidTinFormat') && form.get('tinNumber')?.touched) {
        <div class="text-red-500 text-[10px] mt-1">
          {{ form.get('tinNumber')?.getError('invalidTinFormat')?.message || 'Formato TIN inválido' }}
        </div>
      }
      @if (form.hasError('tinRequired') && form.get('tinNumber')?.touched) {
        <div class="text-red-500 text-[10px] mt-1">
          El número de identificación tributaria es obligatorio
        </div>
      }
    </div>
  }

  <app-selected
    class="w-full"
    [config]="dataSelected().at(5)"
    (selectValue)="handleValue($event)"
  ></app-selected>

  <app-selected
    class="w-full"
    [config]="dataSelected().at(6)"
    (selectValue)="handleValue($event)"
  ></app-selected>

  <button class="btn-primary mb-6" [disabled]="!form.valid">
    Continuar
  </button>
</form>
